<template>
<div class="chapter">
<div class="inner_page">
<p class="C572"><span id="page_1"><img alt="" src="img/2_1.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title_Pa.vue?26c28604